import { useTranslation } from "react-i18next";
import i18n from "../config/i18n";

const text: any = {};

const useText = () => {
  const { t } = useTranslation();
  const lng = i18n.language;
  if (Object.keys(text[lng] || {})?.length === 0) {
    text[lng] = {};
    text[lng].all = {
      the_task: t("the_task"),
      is: t("is"),
      task_id: t("task_id"),
      request_id: t("request_id"),
      see_more: t("see_more"),
      error_occurred: t("error_occurred"),
      advantage: t("advantage"),
      use: t("use"),
      times: t("times"),
      use_now: t("use_now"),
      use_date: t("use_date"),
      location: t("location"),
      offered_by: t("offered_by"),
      areas: t("areas"),
      program: t("program"),
      max_amount: t("max_amount"),
      advantages: t("advantages"),
      dedicated_courier: t("dedicated_courier"),
      dedicated_courier_request: t("dedicated_courier_request"),
      activity: t("activity"),
      dashboard: t("dashboard"),
      parcels: t("parcels"),
      parcel: t("parcel"),
      my_stock: t("my_stock"),
      my_tasks: t("my_tasks"),
      status: t("status"),
      mission: t("mission"),
      task_type: t("task_type"),
      description: t("description"),
      no_product_found_in_catalogue: t("no_product_found_in_catalogue"),
      size: t("size"),
      validate: t("validate"),
      value: t("value"),
      add_product: t("add_product"),
      product_to_pick: t("product_to_pick"),
      product_to_pick_at: t("product_to_pick_at"),
      product_to_drop_in: t("product_to_drop_in"),
      product_to_deliver: t("product_to_deliver"),
      titleStep: t("titleStep"),
      titleStep_2: t("titleStep_2"),
      titleStep_3: t("titleStep_3"),
      titleStep_4: t("titleStep_4"),
      price: t("price"),
      orders: t("orders"),
      address: t("address"),
      date: t("date"),
      pickup: t("pickup"),
      select_from_caalog: t("select_from_caalog"),
      pickup_label: t("pickup_label"),
      show_parcels: t("show_parcels"),
      orderTextInfo: t("orderTextInfo"),
      reception_at_Relay_Point_field: t("reception_at_Relay_Point_field"),
      describe_product_error: t("describe_product_error"),
      article_name: t("article_name"),
      search: t("search"),
      delivery: t("delivery"),
      pending: t("pending"),
      in_progress: t("in_progress"),
      reload: t("reload"),
      add_parcel: t("add_parcel"),
      delete_all_orders: t("delete_all_orders"),
      relay_point: t("relay_point"),
      reception_at_relay: t("reception_at_relay"),
      type: t("type"),
      vehicle: t("vehicle"),
      vehicles: t("vehicles"),
      add_parcels: t("add_parcels"),
      add_tasks: t("add_tasks"),
      created_by: t("created_by"),
      execution_date: t("execution_date"),
      to_collect: t("to_collect"),
      airway_bills: t("airway_bills"),
      my_past_parcels_upload: t("my_past_parcels_upload"),
      due_date: t("due_date"),
      my_parcels_and_letters: t("my_parcels_and_letters"),
      my_profile: t("my_profile"),
      my_clients: t("my_clients"),
      view_more: t("view_more"),
      users: t("users"),
      post: t("post"),
      logout: t("logout"),
      history: t("history"),
      my_history: t("my_history"),
      covenient_delivery: t("covenient_delivery"),
      confirm: t("confirm"),
      back: t("back"),
      sure_to_reschedule: t("sure_to_reschedule"),
      sure_to_delete_task: t("sure_to_delete_task"),
      sure_to_delete_article: t("sure_to_delete_article"),
      confirmation: t("confirmation"),
      created_on: t("created_on"),
      convenient_delivery: t("convenient_delivery"),
      cancel: t("cancel"),
      next: t("next"),
      update: t("update"),
      delete: t("delete"),
      edit: t("edit"),
      choose_the_most: t("choose_the_most"),
      attempts: t("attempts"),
      platform: t("platform"),
      reference: t("reference"),
      first_name: t("first_name"),
      last_name: t("last_name"),
      warehouse_name: t("warehouse_name"),
      phone_number: t("phone_number"),
      service: t("service"),
      representing: t("representing"),
      thank_client: t("thank_client"),
      account_already: t("account_already"),
      desc_success: t("desc_success"),
      all: t("all"),
      completed: t("completed"),
      click_to_add: t("click_to_add"),
      sender: t("sender"),
      receiver: t("receiver"),
      success: t("success"),
      error: t("error"),
      name: t("name"),
      entreprise: t("entreprise"),
      self_registration: t("self_registration"),
      number: t("number"),
      details: t("details"),
      new_parcels: t("new_parcels"),
      cancel_edit_parcels: t("cancel_edit_parcels"),
      cancel_new_parcels: t("cancel_new_parcels"),
      cancel_new_parcels_message: t("cancel_new_parcels_message"),
      cancel_update_parcels_message: t("cancel_update_parcels_message"),
      new_user: t("new_user"),
      client: t("client"),
      validation: t("validation"),
      step: t("step"),
      add: t("add"),
      holidays_text: t("holidays_text"),
      holidays_second_text: t("holidays_second_text"),
      previous: t("previous"),
      drop_off: t("drop_off"),
      drop_off_label: t("drop_off_label"),
      from_stock: t("from_stock"),
      from_stock_label: t("from_stock_label"),
      time: t("time"),
      done: t("done"),
      not_started: t("not_started"),
      add_new_order: t("add_new_order"),
      download_template: t("download_template"),
      upload_template: t("upload_template"),
      receivers_selected: t("receivers_selected"),
      duplicate: t("duplicate"),
      amount_to_collect: t("amount_to_collect"),
      product_to_recover: t("product_to_recover"),
      are_you_done_creating_parcel: t("are_you_done_creating_parcel"),
      are_you_done_updating_parcel: t("are_you_done_updating_parcel"),
      preview_airway_bills: t("preview_airway_bills"),
      airway_bills_helpertext: t("airway_bills_helpertext"),
      number_invalid: t("number_invalid"),
      this_field_is_required: t("this_field_is_required"),
      select_receiver: t("select_receiver"),
      add_receiver: t("add_receiver"),
      edit_receiver: t("edit_receiver"),
      add_client: t("add_client"),
      update_receiver: t("update_receiver"),
      specification: t("specification"),
      order_parcels: t("order_parcels"),
      empty_table: t("empty_table"),
      profile: t("profile"),
      amount_error: t("amount_error"),
      number_already_used: t("number_already_used"),
      email: t("email"),
      manage_your_team: t("manage_your_team"),
      easily: t("easily"),
      last_connexion: t("last_connexion"),
      your_parcels: t("your_parcels"),
      anytime_anywhere: t("anytime_anywhere"),
      vehicle_type: t("vehicle_type"),
      scheduling: t("scheduling"),
      home: t("home"),
      tracking: t("tracking"),
      catalog: t("catalog"),
      request: t("request"),
      requests: t("requests"),
      task: t("task"),
      finished: t("finished"),
      monday: t("monday"),
      tuesday: t("tuesday"),
      wednesday: t("wednesday"),
      thursday: t("thursday"),
      friday: t("friday"),
      saturday: t("saturday"),
      start_date: t("start_date"),
      end_date: t("end_date"),
      slot_start: t("slot_start"),
      slot_end: t("slot_end"),
      sent: t("sent"),
      intervall_date_error: t("intervall_date_error"),
      intervall_slot_error: t("intervall_slot_error"),
      sunday_error: t("sunday_error"),
      until: t("until"),
      my_notifications: t("my_notifications"),
      yes: t("yes"),
      no: t("no"),
      are_sure: t("are_sure"),
      order: t("order"),
      nothing_selected: t("nothing_selected"),
      we_send_you_a_papser: t("we_send_you_a_papser"),
      recap: t("recap"),
      add_new_receiver: t("add_new_receiver"),
      quit: t("quit"),
      what_can_we_do_for_you_today: t("what_can_we_do_for_you_today"),
      from: t("from"),
      to: t("to"),
      hello: t("hello"),
      request_quote: t("request_quote"),
      send_parcels: t("send_parcels"),
      edit_client: t("edit_client"),
      template_uploading_error: t("template_uploading_error"),
      filter: t("filter"),
      filter_by_date: t("filter_by_date"),
      filter_by_task: t("filter_by_task"),
      creation_date: t("creation_date"),
      pagination_of: t("pagination_of"),
      accept: t("accept"),
      decline: t("decline"),
      required_field: t("required_field"),
      return_to_the_website: t("return_to_the_website"),
      sure_to_delete: t("sure_to_delete"),
      are_done_creating: t("are_done_creating"),
      create: t("create"),
      are_done_updating: t("are_done_updating"),
      category: t("category"),
      see_details: t("see_details"),
      error_getting_data: t("error_getting_data"),
      of: t("of"),
      shipment: t("shipment"),
      when: t("when"),
      pickup_location: t("pickup_location"),
      destination: t("destination"),
      action: t("action"),
      where_to_pick: t("where_to_pick"),
      where_to_go: t("where_to_go"),
      pickup_delivery: t("pickup_delivery"),
      and_or: t("and_or"),
      not_valid_format: t("not_valid_format"),
      are_you_want_accept_request: t("are_you_want_accept_request"),
      are_you_want_decline_request: t("are_you_want_decline_request"),
      quantity: t("quantity"),
      change_receiver: t("change_receiver"),
      phone_number_placeholder: t("phone_number_placeholder"),
      close: t("close"),
      new: t("new"),
      export_task: t("export_task"),
      to_date: t("to_date"),
      task_status: t("task_status"),
      export_date_validation: t("export_date_validation"),
      empty_task: t("empty_task"),
      task_UID: t("task_UID"),
      receiver_fullname: t("receiver_fullname"),
      receiver_phone_number: t("receiver_phone_number"),
      city: t("city"),
      completion_date: t("completion_date"),
      export_parcel: t("export_parcel"),
      parcel_UID: t("parcel_UID"),
      delivery_date: t("delivery_date"),
      empty_parcel: t("empty_parcel"),
      updated_at: t("updated_at"),
      export_success: t("export_success"),
      additionals_infos: t("additionals_infos"),
      discard_and_close: t("discard_and_close"),
      keep_this_open: t("keep_this_open"),
      do_you_want_to_discard_them: t("do_you_want_to_discard_them"),
      your_changes_wont_be: t("your_changes_wont_be"),
      additional_infos: t("additional_infos"),
      new_job_delivery_info_main: t("new_job_delivery_info_main"),
      new_job_delivery_info_main_afternoon: t("new_job_delivery_info_main_afternoon"),
      new_job_delivery_info_main_afternoon_without_article: t("new_job_delivery_info_main_afternoon_without_article"),
      new_job_delivery_info_main_tomorrow: t("new_job_delivery_info_main_tomorrow"),
      article_the: t("article_the"),
      confirm_update_parcel_message: t("by_clicking_on_edit_i_confirm_that_i_will_download"),
      discover_today_gift: t("discover_today_gift"),
      gift: t("gift"),
      local_time_ago: t("local_time_ago"),
      set_out_of_stock: t("set_out_of_stock"),
      read_notification_error: t("read_notification_error"),
      back_to_login: t("back_to_login"),
      forgot_password: t("forgot_password"),
      email_verified_message: t("email_verified_message"),
      please_enter_a_correct_value: t("please_enter_a_correct_value"),
      experience_the_best_delivery_in_africa: t("Experience the best delivery in Africa"),
      register_now: t("register_now"),
      per_page: t("per_page"),
      stay_button_dialog: t("stay_button_dialog"),
      discard_button_dialog: t("discard_button_dialog"),
      update_parcel: t("update_parcel"),
      reset: t("reset"),
      costs: t("costs"),
      amount: t("amount"),
      proof: t("proof"),
      no_proof: t("no_proof"),
      add_new_address: t("add_new_address"),
      set_up_and_have_a_global_view_on: t("set_up_and_have_a_global_view_on"),
      your_different_point_of_sale: t("your_different_point_of_sale"),
      my_address: t("my_address"),
      want_to_delete: t("want_to_delete"),
      address_name: t("address_name"),
      reason: t("reason"),
      not_reive: t("not_reive"),
      date_range_modal: t("date_range_modal"),
      elements: t("elements"),
      select_a_vehicle: t("select_a_vehicle"),
      download: t("download"),
      date_to: t("date_to"),
      yes_i_confirm: t("yes_i_confirm"),
      no_cancel_acceptation: t("no_cancel_acceptation"),
      no_cancel_declining: t("no_cancel_declining"),
      to_have_a_global_view_on_your: t("to_have_a_global_view_on_your"),
      report_problem: t("report_problem"),
      stops: t("stops"),
      quote_available: t("quote_available"),
      request_follow_up: t("request_follow_up"),
      unavailable_pickup_address: t("unavailable_pickup_address"),
      select_pickup_address: t("select_pickup_address"),
      delay: t("delay"),
      edit_address_success: t("edit_address_success"),
      add_address_success: t("add_address_success"),
      pickup_address: t("pickup_address"),
      product_description: t("product_description"),
      delivery_address: t("delivery_address"),
      select_delivery_address: t("select_delivery_address"),
      request_tour_title: t("request_tour_title"),
      contact_name: t("contact_name"),
      mailing: t("mailing"),
      deleted: t("deleted")
    };

    text[lng].receiver = {
      receiver_deletion: t("receiver_deletion"),
      message_deletion: t("message_deletion"),
      receiver_already_added: t("receiver_already_added"),
    };
    text[lng].status = {
      unassigned: t("unassigned"),
      assigned: t("assigned"),
      completed: t("completed"),
      to_reschedule: t("to_reschedule"),
      successful: t("successful"),
      in_progress: t("in_progress"),
      cancelled: t("cancelled"),
    };
    text[lng].users = {
      user_updated_msg: t("user_updated_msg"),
      user_not_updated_msg: t("user_not_updated_msg"),
    };
    text[lng].task = {
      reschedule_task: t("reschedule_task"),
    };
    text[lng].order = {
      order_deletion: t("order_deletion"),
    };
    text[lng].parcel = {
      pickup_dropoff_tab: t("pickup_dropoff_tab"),
      airway_bills_tab: t("airway_bills_tab"),
      how_are_the_parcel: t("how_are_the_parcel"),
      add_client_to_be_delivered: t("add_client_to_be_delivered"),
      add_parcel_for: t("add_parcel_for"),
      validate_to_create_job: t("validate_to_create_job"),
      wait_while_the_parcel: t("wait_while_the_parcel"),
      parcels_to_pick: t("parcels_to_pick"),
      parcels_tracking: t("parcels_tracking"),
      today_text: t("today_text"),
      filtrer_text: t("filtrer_text"),
      placeholder_from: t("placeholder_from"),
      placeholder_to: t("placeholder_to"),
      placeholder_exec_date: t("placeholder_exec_date"),
      parcel_deletion: t("parcel_deletion"),
      parcel_update: t("parcel_update"),
      parcels_to: t("parcels_to"),
      parcel_uploaded_successfully: t("parcel_uploaded_successfully"),
      upload_failed_file_header_error: t("upload_failed_file_header_error"),
      upload_failed_no_parcels: t("upload_failed_no_parcels"),
      create_date: t("create_date"),
      different_pick_up_addresses: t("different_pick_up_addresses"),
    };
    text[lng].client = {
      client_reference: t("client_reference"),
      manage_your_client: t("manage_your_client"),
    };
    text[lng].user = {
      user_update: t("user_update"),
      add_new_user: t("add_new_user"),
      user_creation: t("user_creation"),
      user_role: t("user_role"),
      change_password: t("change_password"),
      old_password: t("old_password"),
      new_password: t("new_password"),
      repeat_password: t("repeat_password"),
      edit_profile: t("edit_profile"),
      password_helpertext: t("password_helpertext"),
      add_photo: t("add_photo"),
      edit_photo: t("edit_photo"),
    };
    text[lng].vehicle = {
      motocycle_tooltip: t("motocycle_tooltip"),
      treecycle_tooltip: t("treecycle_tooltip"),
      van_tooltip: t("van_tooltip"),
      vanXl_tooltip: t("vanXl_tooltip"),
      truck_tooltip: t("truck_tooltip"),
    };
    text[lng].homePage = {
      easy_colis_text: t("easy_colis_text"),
      sama_papser_text: t("sama_papser_text"),
      national_transport_text: t("national_transport_text"),
      national_transport_title: t("national_transport_title"),
      paps_tour_text: t("paps_tour_text"),
      paps_tour_title: t("paps_tour_title"),
      distribution_title: t("distribution_title"),
      course_title: t("course_title"),
      course_text: t("course_text"),
    };
    text[lng].requestQuote = {
      reccurence_option_error: t("reccurence_option_error"),
      vehicle_type_error: t("vehicle_type_error"),
      truck_type_error: t("truck_type_error"),
      reccurence_day_error: t("reccurence_day_error"),
      select_truck_type: t("select_truck_type"),
      reccurence_not_repeat: t("reccurence_not_repeat"),
      reccurence_daily: t("reccurence_daily"),
      reccurence_daily_card: t("reccurence_daily_card"),
      reccurence_weekly: t("reccurence_weekly"),
      reccurence_monthly: t("reccurence_monthly"),
      reccurence_annually: t("reccurence_annually"),
      reccurence_repeat_label: t("reccurence_repeat_label"),
      custom: t("custom"),
      reccurence_modal_name: t("reccurence_modal_name"),
      does_it_require_dispatcher: t("does_it_require_dispatcher"),
      mad_request_message_creation: t("mad_request_message_creation"),
      mad_request_button_creation: t("mad_request_button_creation"),
      mad_request_message_update: t("mad_request_message_update"),
      mad_request_message_delete: t("mad_request_message_delete"),
      does_it_require_handler: t("does_it_require_handler"),
      reccurence_type_days: t("reccurence_type_days"),
      reccurence_type_weeks: t("reccurence_type_weeks"),
      reccurence_type_months: t("reccurence_type_months"),
      reccurence_type_year: t("reccurence_type_year"),
      reccurence_day_option_monday: t("reccurence_day_option_monday"),
      reccurence_day_option_tuesday: t("reccurence_day_option_tuesday"),
      reccurence_day_option_wednesday: t("reccurence_day_option_wednesday"),
      reccurence_day_option_thursday: t("reccurence_day_option_thursday"),
      reccurence_day_option_friday: t("reccurence_day_option_friday"),
      reccurence_day_option_saturday: t("reccurence_day_option_saturday"),
      reccurence_value_label: t("reccurence_value_label"),
      reccurence_every: t("reccurence_every"),
      reccurence_month: t("reccurence_month"),
      reccurence_on_the_last: t("reccurence_on_the_last"),
      reccurence_day_number_completion_st: t("reccurence_day_number_completion_st"),
      reccurence_day_number_completion_nd: t("reccurence_day_number_completion_nd"),
      reccurence_day_number_completion_rd: t("reccurence_day_number_completion_rd"),
      reccurence_day_number_completion_th: t("reccurence_day_number_completion_th"),
      reccurence_every_1_week: t("reccurence_every_1_week"),
      reccurence_every_2_week: t("reccurence_every_2_week"),
      reccurence_every_3_week: t("reccurence_every_3_week"),
      reccurence_every_4_week: t("reccurence_every_4_week"),
      reccurence_every_5_week: t("reccurence_every_5_week"),
      select_product_type: t("select_product_type"),
      additionnal_details: t("additionnal_details"),
      product: t("product"),
      product_type_courrier: t("product_type_courrier"),
      product_type_fragile: t("product_type_fragile"),
      product_type_food: t("product_type_food"),
      product_type_fresh_products: t("product_type_fresh_products"),
      product_type_other: t("product_type_other"),
      terms_group_1: t("terms_group_1"),
      terms_group_clickable: t("terms_group_clickable"),
      terms_group_final: t("terms_group_final"),
      desc_vehicle_1: t("desc_vehicle_1"),
      desc_vehicle_2: t("desc_vehicle_2"),
      desc_vehicle_3: t("desc_vehicle_3"),
      desc_vehicle_4: t("desc_vehicle_4"),
      truck: t("truck"),
      placeholder_reccurence: t("placeholder_reccurence"),
      reccurence_each: t("reccurence_each"),
      reccurence_on: t("reccurence_on"),
      request_details: t("request_details"),
      canceling_modal: t("canceling_modal"),
      canceling_confirmation_message: t("canceling_confirmation_message"),
      new_request_quote: t("new_request_quote"),
      samapaser: t("samapaser"),
      national_transport: t("national_transport"),
      tour: t("tour"),
      my_quotes: t("my_quotes"),
      request_requested: t("request_requested"),
      request_accepted: t("request_accepted"),
      request_approved: t("request_approved"),
      request_declined: t("request_declined"),
      confirmation_request_quote: t("confirmation_request_quote"),
      accepted_request_quote: t("accepted_request_quote"),
      approved_request_quote: t("approved_request_quote"),
      successfully_created: t("successfully_created"),
      error_created: t("error_created"),
      national_transport_label_step_1: t("national_transport_label_step_1"),
      national_transport_label_step_2: t("national_transport_label_step_2"),
      national_transport_label_step_3: t("national_transport_label_step_3"),
      accept_request: t("accept_request"),
      decline_request: t("decline_request"),
      add_destination_point: t("add_destination_point"),
      complete_point_error: t("complete_point_error"),
      points_validator_error: t("points_validator_error"),
      points_tour_validator_error: t("points_tour_validator_error"),
      reccurence_NT_info: t("reccurence_NT_info"),
      error_devis_file: t("error_devis_file"),
      filter_by_mission_type: t("filter_by_mission_type"),
      filter_by_request_status: t("filter_by_request_status"),
      articles_to_pick_title: t("articles_to_pick_title"),
      articles_to_deliver_title: t("articles_to_deliver_title"),
      add_axe_button: t("add_axe_button"),
      define_reccurency: t("define_reccurency"),
      axe_select_vehicle: t("axe_select_vehicle"),
      add_stop_button: t("add_stop_button"),
      vehicles_chosen: t("vehicles_chosen"),
      discount: t("discount"),
      sama_papser_form_products_placeholder: t("sama_papser_form_products_placeholder"),
      new_request: t("new_request"),
      add_another_axe_button: t("add_another_axe_button"),
    };
    text[lng].catalog = {
      new_article: t("new_article"),
      my_catalog: t("my_catalog"),
      article_label: t("article_label"),
      reference_label: t("reference_label"),
      description_label: t("description_label"),
      article_detail: t("article_detail"),
      title_dialog_delete: t("title_dialog_delete"),
      select_article_from_catalog: t("select_article_from_catalog"),
      describe_article: t("describe_article"),
      describe_article_title: t("describe_article_title"),
      error_size: t("error_size"),
      select_article_to_delivery: t("select_article_to_delivery"),
      error_define_first_point: t("error_define_first_point"),
      articles: t("articles"),
      describe_article_to_deliver: t("describe_article_to_deliver"),
      article_name: t("article_name"),
      deliver: t("deliver"),
    };
    text[lng].tracking_history = {
      history_cancelled: t("history_cancelled"),
      history_picked: t("history_picked"),
      history_assigned: t("history_assigned"),
      history_handed_over: t("history_handed_over"),
      history_reconciled: t("history_reconciled"),
      history_money_to_collect: t("history_money_to_collect"),
      history_to_pick: t("history_to_pick"),
      history_to_receive: t("history_to_receive"),
      history_awaiting_delivery: t("history_awaiting_delivery"),
      history_to_be_assigned: t("history_to_be_assigned"),
      history_on_delivery: t("history_on_delivery"),
      history_delivered: t("history_delivered"),
      history_failed: t("history_failed"),
      history_successful: t("history_successful"),
      history_returned: t("history_returned"),
      history_not_receive: t("history_not_receive"),
      history_to_hand_over: t("history_to_hand_over"),
      history_completed: t("history_completed"),
      history_to_return: t("history_to_return"),
      history_r_to_hand_over: t("history_r_to_hand_over"),
      history_r_to_be_assigned: t("history_r_to_be_assigned"),
      history_on_return: t("history_on_return"),
      history_partially_received: t("history_partially_received"),
      history_partially_completed: t("history_partially_completed"),
      history_pick_failed: t("history_pick_failed"),
      history_sent_back: t("history_sent_back"),
      history_to_prepare: t("history_to_prepare"),
    };

    text[lng].pagination = {
      pagination_show: t("pagination_show"),
    };
    text[lng].redirect_page = {
      greetings: t("redirect_page_greetings"),
      intro: t("redirect_page_intro"),
      message: t("redirect_page_message"),
      date: t("redirect_page_date"),
      bookmark: t("redirect_page_bookmark"),
      current_url: t("redirect_page_current_url"),
      new_url: t("redirect_page_new_url"),
      closing: t("redirect_page_closing"),
      signature: t("redirect_page_signature"),
    };
    text[lng].confirmation_account = {
      confirmation_account_error: t("confirmation_account_error"),
      confirmation_account_server_error: t("confirmation_account_server_error"),
      confirmation_account_not_match: t("confirmation_account_not_match"),
      confirmation_account_verification: t("confirmation_account_verification"),
      confirmation_account_password: t("confirmation_account_password"),
      confirmation_account_password_error: t("confirmation_account_password_error"),
      confirmation_account_repeat_password: t("confirmation_account_repeat_password"),
      confirmation_account_confirm: t("confirmation_account_confirm"),
      confirmation_account_back_to_login: t("confirmation_account_back_to_login"),
    };
    text[lng].notification = {
      new_notification: t("new_notification"),
    };
    text[lng].cash_management = {
      all_cash_collected: t("all_cash_collected"),
      collected_by_papser: t("collected_by_papser"),
      collected_by_cashier: t("collected_by_cashier"),
      yet_to_collect: t("yet_to_collect"),
      failed_to_collect: t("failed_to_collect"),
      in_remittance: t("in_remittance"),
      remittance_ongoing: t("remittance_ongoing"),
      remittance_confirmed: t("remittance_confirmed"),
      clear_filter: t("clear_filter"),
      remittance: t("remittance"),
      remittance_at_paps: t("remittance_at_paps"),
      not_receive: t("not_receive"),
      confirm_remittance_succes_message: t("confirm_remittance_succes_message"),
      not_receive_remittance_succes_message: t("not_receive_remittance_succes_message"),
      cash_payment: t("cash_payment"),
      confirm_reception_message: t("confirm_reception_message"),
      decline_reception_message: t("decline_reception_message"),
      remittance_id: t("remittance_id"),
      confirmation_date: t("confirmation_date"),
      collect_interval: t("collect_interval"),
      cash_status: t("cash_status"),
      cash_collected_date: t("cash_collected_date"),
      remit_due_date: t("remit_due_date"),
      remit_confirm_date: t("remit_confirm_date"),
      created_by_ops_agent: t("created_by_ops_agent"),
      received_by_client: t("received_by_client"),
      not_received_by_client: t("not_received_by_client"),
      parcels_added_by_ops_agent: t("parcels_added_by_ops_agent"),
      parcels_deleted_by_ops_agent: t("parcels_deleted_by_ops_agent"),
      resend_remittance: t("resend_remittance"),
      view_proof: t("view_proof"),
      remittance_declined: t("remittance_declined"),
    };
    text[lng].fidelity_program = {
      brand_title: t("brand_title"),
      fidelity_program: t("fidelity_program"),
      my_fidelity_program: t("my_fidelity_program"),
      only_applicable_in: t("only_applicable_in"),
      usable_for: t("usable_for"),
      premium_advantage: t("premium_advantage"),
      fidelity_history_title: t("fidelity_history_title"),
      fidelity_program_title: t("fidelity_program_title"),
      use_advantage_success_message: t("use_advantage_success_message"),
      use_advantage_error_message: t("use_advantage_error_message"),
      ending_periode: t("ending_periode"),
      sorry_to_not_register: t("sorry_to_not_register"),
      you_can_see_benefits: t("you_can_see_benefits"),
      title: t("title"),
    };
    text[lng].course = {
      select_course_pickup_address: t("select_course_pickup_address"),
      select_course_delivery_address: t("select_course_delivery_address"),
      new_address: t("new_address"),
      edit_address: t("edit_address"),
      add_product: t("add_product"),
      product_pickup: t("product_pickup"),
      another_pickup: t("another_pickup"),
      another_delivery: t("another_delivery"),
      course_edition_success: t("course_edition_success"),
      course_creation_success: t("course_creation_success"),
      pickup_delivery_validation_warning: t("pickup_delivery_validation_warning"),
      course_creation_warning: t("course_creation_warning"),
      course_edition: t("course_edition"),
      course_creation: t("course_creation"),
      course_creation_message: t("course_creation_message"),
      new_course: t("new_course"),
      new_course_message: t("new_course_message"),
      cancel_course_message: t("cancel_course_message"),
      cancel_course_title: t("cancel_course_title"),
    };
  }
  return { text: text[lng] };
};

export default useText;
